<template>
  <div>
    <popup
      ref="popup"
      round
      v-model="show"
      position="bottom"
      :close-on-click-overlay="false"
      :lazy-render="false"
    >
      <div class="popup-title">
        <span class="popup-cancel" @click="popupCancel">取消</span>
        <span class="popup-title-text">选择出生时辰</span>
        <span class="popup-confirm" @click="popupConfirm">确定</span>
      </div>
      <picker
        ref="datetime"
        :columns="columnss"
        :show-toolbar="false"
        visible-item-count="5"
      >
        <!-- <template v-slot:option="item">
          <div class="picker-item">
            <div>{{ item.title }}</div>
            <div>{{ item.time }}</div>
          </div>
        </template> -->
      </picker>
    </popup>
  </div>
</template>

<script>
/**
@description:选择时间组件
@createTime:2021-09-21
@create:wq
*/
import { Popup, Picker } from "vant";

export default {
  name: "",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    date: {
      type: String,
      default: "请选择出生年月日",
    },
  },
  model: {
    prop: "show",
    event: "changeShow",
  },

  components: { Popup, Picker },
  data() {
    return {
      columnss: [
        "子时 23:00-00:59",
        "丑时 01:00-02:59",
        "寅时 03:00-04:59",
        "卯时 05:00-06:59",
        "辰时 07:00-08:59",
        "巳时 09:00-10:59",
        "午时 11:00-12:59",
        "未时 13:00-14:59",
        "申时 15:00-16:59",
        "酉时 17:00-18:59",
        "戌时 19:00-20:59",
        "亥时 21:00-22:59",
      ],
      columns: [
        {
          title: "子时",
          time: "23:00-00:59",
        },
        {
          title: "丑时",
          time: "01:00-02:59",
        },
        {
          title: "寅时",
          time: "03:00-04:59",
        },
        {
          title: "卯时",
          time: "05:00-06:59",
        },
        {
          title: "辰时",
          time: "07:00-08:59",
        },
        {
          title: "巳时",
          time: "09:00-10:59",
        },
        {
          title: "午时",
          time: "11:00-12:59",
        },
        {
          title: "未时",
          time: "13:00-14:59",
        },
        {
          title: "申时",
          time: "15:00-16:59",
        },
        {
          title: "酉时",
          time: "17:00-18:59",
        },
        {
          title: "戌时",
          time: "19:00-20:59",
        },
        {
          title: "亥时",
          time: "21:00-22:59",
        },
      ],
    };
  },
  computed: {},
  watch: {
    show() {
      this.type = this.lunar;
      if (this.date !== "请选择出生时辰") {
        // const arr = this.date.split("-");
        this.$refs.datetime.setValues([this.date]);
      }
    },
  },
  mounted() {},
  created() {},
  methods: {
    popupCancel() {
      this.$emit("changeShow", false);
    },
    popupConfirm() {
      const date = this.$refs.datetime.getValues().join("-");
      this.$emit("changeShow", false);
      this.$emit("confirm", { date: date });
    },
  },
};
</script>
<style lang="scss" scoped>
.popup-title {
  width: 100%;
  height: 50px;
  background: #f6f6f6;
  font-size: 15px;
  font-weight: 500;
  color: #333333;
  box-sizing: border-box;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .popup-cancel {
    color: #666666;
  }
  .popup-title-text {
    font-weight: bold;
  }
  .popup-confirm {
  }
}
.switch-gy {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e3e3e3;
  box-sizing: border-box;
  padding: 0 15px;

  .switch-gy-tilte {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }
  .switch {
    width: 120px;
    height: 30px;
    background: #f6f6f6;
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    border: 1px solid #e3e3e3;
    > span {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .action {
      color: #ffffff;
      background: #34c290;
    }
  }
}
.picker-item {
  width: 100%;
  display: flex;
  align-items: center;
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
